import React, { useContext } from 'react';
import { GlobalContext } from "../../common/context";
import Products from "../../common/screens/products";
import Cart from "../flow3/cart";

const Flow3App = () => {
  const { step, initialLoading } = useContext(GlobalContext);
  return (
    <>
      { step === 'products' && <Products initialLoading={ initialLoading } /> }
      { step === 'cart' && <Cart /> }
    </>
  );
};

export default Flow3App;
